// src/pages/LandingPages/June2025/LandingPage.jsx

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import getEnvConfig from '../../../config'; // your config helper for backendUrl
import MainNavbar from '../../../Components/Navbars/MainNavbar';
import Footer from '../../../Components/Footer';
import {
  Container,
  Row,
  Col,
  Card,
  CardGroup,
  Button,
  Accordion,
  Form,
} from 'react-bootstrap';

// ——— ROI constants ———
const AVERAGE_SESSIONS = 60;
const AVERAGE_KWH = 20;
const PRICE_PER_KWH = 0.3;

function ThankYouPage() {
  useEffect(() => {
    if (window.gtag) {
      window.gtag('event', 'conversion', {
        send_to: 'AW-17093263348/LMvNCKjp6tAaEPT_2dY_',   // <-- your ID/label pair
      });
    }
  }, []);

  return <p className="text-success">Thank you!</p>;
}


const LandingPage = () => {
  const { backendUrl } = getEnvConfig();

  useEffect(() => {
    // Check that the gtag library is loaded
    if (window.gtag) {
      // 2.1.1 Tell Google “we’re now on the landing page” with a timestamp
      window.gtag('js', new Date());


      window.gtag('config', 'AW-17093263348');
    }
  }, []); // Empty dependency array → runs ONCE after first render

  // ROI calculator state
  const [spots, setSpots] = useState(5);
  const [utilization, setUtilization] = useState(50);
  const monthlyRevenue = Math.round(
    spots * (utilization / 100) * AVERAGE_SESSIONS * AVERAGE_KWH * PRICE_PER_KWH
  );

  // “Request Free Quote” form state
  const [leadData, setLeadData] = useState({ name: '', email: '', phone: '' , message: 'from landing page, requested a quote and more information', recaptchaToken: ''});
  const [loadingLead, setLoadingLead] = useState(false);
  const [leadStatus, setLeadStatus] = useState(null); // 'success' | 'error' | null
  const [loading, setLoading] = useState(false);


  const handleLeadChange = (e) => {
    const { name, value } = e.target;
    setLeadData({ ...leadData, [name]: value });
  };

  const SubmitLead = async (e) => {
    e.preventDefault();
    setLoadingLead(true);
    try {

      if (!window.grecaptcha || !window.grecaptcha.enterprise) {
            throw new Error('reCAPTCHA script not loaded');
      }
      const recaptchaToken = await window.grecaptcha.enterprise.execute('6Le3zz4qAAAAAPM0hIuJo-earCVfKKXOilv4ltOY', { action: 'SUBMIT_LEAD' });        
      console.log('recaptchaToken', recaptchaToken);
      console.log(recaptchaToken);
      leadData.recaptchaToken = recaptchaToken;

      const resp = await axios.post(`${backendUrl}/support/contact`, leadData);
      
      if (resp.data.success) {
        setLeadStatus('success');

      } else {
        setLeadStatus('error');
      }
    } catch (err) {
      console.error(err);
      setLeadStatus('error');
    } finally {
      setLoadingLead(false);
    }

  };

  return (
    <Container fluid className="p-0" style={{ width: '80%' }}>
      <MainNavbar />

      {/* ================= Hero Section ================= */}
      <Row className="m-0" style={{ height: '70vh', position: 'relative', marginTop: '100px', marginBottom: '100px' }}>
        <div
          className="w-100"
          style={{
            backgroundImage: `url(/images/landingPageJune2025/hero-bg.png)`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            filter: 'brightness(0.7)',
            height: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
          }}
        />
        <Col
          xs={12}
          className="d-flex flex-column justify-content-center align-items-center text-center text-white"
          style={{ zIndex: 1 }}
        >
          <h1 className="display-4 fw-bold">Monetize Your Parking — Effortlessly.</h1>
          <p className="lead mb-4">
            Install Level 2 Chargers in Multi-Family & Commercial Lots, Earn Recurring Income ● No DC Fast Cost.
          </p>
          <Button
            variant="warning"
            className="px-4 py-2 fw-semibold"
            style={{ color: '#0A3D35' }}
            href="#quote-form"
          >
            Get Your Free Quote
          </Button>
          <a href="#how-it-works" className="mt-3 text-white text-decoration-underline">
            See How It Works ↓
          </a>
        </Col>
      </Row>

      {/* ================ Mini‐Hero Bar ================ */}
      <Row className="bg-dark text-white py-2" style={{ marginTop: '10px', marginBottom: '10px' }}>
        <Container>
          <Row className="justify-content-center py-0 mb-0">
            <Col
              xs={12}
              sm={4}
              className="d-flex align-items-center justify-content-center"
            >
              <img src="/images/landingPageJune2025/cost-icon.png" alt="Cost icon" width="56" height="56" className="me-1" />
              <a href="#pricing" className="text-white text-decoration-none fw-semibold">
                Low Up-Front Costs & Fees
              </a>
            </Col>
            <Col
              xs={12}
              sm={4}
              className="d-flex align-items-center justify-content-center "
            >
              <img src="/images/landingPageJune2025/clock-icon.png" alt="Clock icon" width="56" height="56" className="me-1" />
              <a href="#how-it-works" className="text-white text-decoration-none fw-semibold">
                Perfect for 2 hr+ Parking
              </a>
            </Col>
            <Col xs={12} sm={4} className="d-flex align-items-center justify-content-center">
              <img src="/images/landingPageJune2025/revenue-icon.png" alt="Revenue icon" width="56" height="56" className="me-1" />
              <a href="#roi" className="text-white text-decoration-none fw-semibold">
                Earn ~$200/mo per Charger
              </a>
            </Col>
          </Row>
        </Container>
      </Row>

      {/* ============ How It Works (3 Steps) ============ */}
      <Row id="how-it-works" className="py-5 bg-light" style={{ marginTop: '10px', marginBottom: '10px' }}>
        <Container>
          <Col xs={12} className="text-center mb-4">
            <h2 className="fw-bold">How EVChron Works</h2>
            <p className="text-muted">In 3 easy steps, start earning from your parking spaces.</p>
          </Col>
          <CardGroup>
            <Card className="text-center mx-2 shadow-sm">
              <Card.Body>
                <img src="/images/landingPageJune2025/orderchargers.png" alt="Assessment" width="80" height="80" />
                <Card.Title className="mt-3">Order Your Chargers</Card.Title>
                <Card.Text className="text-muted">
                  Buy Level 2 chargers directly from us at competitive, model-dependent pricing. Each unit comes with a 2–5 year replacement warranty.
                </Card.Text>
              </Card.Body>
            </Card>
            <Card className="text-center mx-2 shadow-sm">
              <Card.Body>
                <img src="/images/landingPageJune2025/installconnect.png" alt="Dashboard" width="80" height="80" />
                <Card.Title className="mt-3">Install & Connect</Card.Title>
                <Card.Text className="text-muted">
                  We ship chargers and guide your electrician (yours or ours) through installation. Then we configure each unit on our smart-charger network for remote monitoring and diagnostics.
                </Card.Text>
              </Card.Body>
            </Card>
            <Card className="text-center mx-2 shadow-sm">
              <Card.Body>
                <img src="/images/landingPageJune2025/sharerevenue.png" alt="Earn" width="80" height="80" />
                <Card.Title className="mt-3">Share the Revenue</Card.Title>
                <Card.Text className="text-muted">
                  You pay a low % of usage + a fixed yearly communication fee. We succeed when you succeed—no large up-front contracts. Ship replacements fast if hardware issues arise.
                </Card.Text>
              </Card.Body>
            </Card>
          </CardGroup>
        </Container>
      </Row>

      {/* ========== Interactive ROI Calculator ========== */}
      <Row id="roi" className="py-5">
        <Container>
          <Col xs={12} className="text-center mb-4">
            <h2 className="fw-bold">What Could You Earn?</h2>
            <p className="text-muted">
              Adjust the sliders below for a ballpark revenue estimate.
            </p>
          </Col>

          <Row className="justify-content-center">
            <Col xs={12} md={8}>
              <Card className="p-4 shadow-sm">
                <Form>
                  <Form.Group as={Row} className="mb-3" controlId="spotsRange">
                    <Form.Label column xs={12} md={6}>
                      Number of Parking Spots: <strong>{spots}</strong>
                    </Form.Label>
                    <Col xs={12} md={6}>
                      <Form.Range
                        min={1}
                        max={50}
                        value={spots}
                        onChange={(e) => setSpots(Number(e.target.value))}
                      />
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} className="mb-3" controlId="utilRange">
                    <Form.Label column xs={12} md={6}>
                      Estimated Utilization: <strong>{utilization}%</strong>
                    </Form.Label>
                    <Col xs={12} md={6}>
                      <Form.Range
                        min={10}
                        max={100}
                        step={5}
                        value={utilization}
                        onChange={(e) => setUtilization(Number(e.target.value))}
                      />
                    </Col>
                  </Form.Group>

                  <div className="text-center mb-3">
                    <h4>
                      Estimated Monthly Revenue:{' '}
                      <span className="fw-bold">
                        ${monthlyRevenue.toLocaleString()}
                      </span>
                    </h4>
                    <small className="text-muted">
                      Assumes $0.30/kWh, 20 kWh per session,{' '}
                      {Math.round((utilization / 100) * AVERAGE_SESSIONS)} sessions/spot/mo
                    </small>
                  </div>
                </Form>

                {/* —— “Request Detailed Report” form —— */}
                <hr />
                <Col xs={12} id="quote-form">
                  <h5 className="fw-semibold mb-3">Request Detailed Report</h5>
                  <Form onSubmit={SubmitLead}>
                    <Form.Group className="mb-3" controlId="leadName">
                      <Form.Label>Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Your Name"
                        value={leadData.name}
                        onChange={handleLeadChange}
                        required
                      />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="leadEmail">
                      <Form.Label>Email</Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        placeholder="Your Email"
                        value={leadData.email}
                        onChange={handleLeadChange}
                        required
                      />
                    </Form.Group>

                    <Form.Group className="mb-4" controlId="leadPhone">
                      <Form.Label>Phone</Form.Label>
                      <Form.Control
                        type="tel"
                        name="phone"
                        placeholder="Your Phone"
                        value={leadData.phone}
                        onChange={handleLeadChange}
                      />
                    </Form.Group>

                    <Button
                      variant="warning"
                      className="w-100 fw-semibold"
                      style={{ color: '#0A3D35' }}
                      type="submit"
                      disabled={loadingLead}
                    >
                      {loadingLead ? 'Sending…' : 'Send My Report'}
                    </Button>

                    {leadStatus === 'success' && (
                      <p className="mt-3 text-success text-center">
                        Thank you! We’ll be in touch shortly.
                      </p>
                    )}
                    {ThankYouPage()}
                    {leadStatus === 'error' && (
                      <p className="mt-3 text-danger text-center">
                        Oops—something went wrong. Please try again.
                      </p>
                    )}
                  </Form>
                  
                </Col>
              </Card>
            </Col>
          </Row>
        </Container>
      </Row>

      {/* ============== Key Benefits Grid ============== */}
      <Row className="py-5 bg-light">
        <Container>
          <Col xs={12} className="text-center mb-4">
            <h2 className="fw-bold">Why Property Managers Love EVChron</h2>
            <p className="text-muted">
              Everything you need in one turnkey EV charging solution.
            </p>
          </Col>
          <CardGroup>
            <Card className="mx-2 shadow-sm">
              <Card.Body className="text-center">
                <Card.Title>Low Up-Front Costs</Card.Title>
                <Card.Text className="text-muted">
                  • Buy chargers at competitive, model-dependent pricing with 2–5 year warranty. <br />
                  • No installation markup—work with your electrician (we can recommend if needed).
                </Card.Text>
              </Card.Body>
            </Card>
            <Card className="mx-2 shadow-sm">
              <Card.Body className="text-center">
                <Card.Title>Revenue-Share Model</Card.Title>
                <Card.Text className="text-muted">
                  • We only make money when you do—low % of usage plus a small yearly comms fee. <br />
                  • Negotiate exact rates so your up-front costs stay minimal.
                </Card.Text>
              </Card.Body>
            </Card>
            <Card className="mx-2 shadow-sm">
              <Card.Body className="text-center">
                <Card.Title>Remote Diagnostics & Support</Card.Title>
                <Card.Text className="text-muted">
                  • Chargers tie into our cloud—24/7 uptime monitoring. <br />
                  • We ship replacements fast if hardware failure occurs.
                </Card.Text>
              </Card.Body>
            </Card>
            <Card className="mx-2 shadow-sm">
              <Card.Body className="text-center">
                <Card.Title>Flexible Installation</Card.Title>
                <Card.Text className="text-muted">
                  • We ship directly; you choose your electrician (or ours) to install. <br />
                  • Complete setup assistance—just plug into our network.
                </Card.Text>
              </Card.Body>
            </Card>
          </CardGroup>
        </Container>
      </Row>

      {/* ============= Simple, Transparent Pricing ============= */}
      <Row id="pricing" className="py-5">
        <Container>
            <Row className="justify-content-center">
                <Col xs={12} className="text-center mb-4">
                    <h2 className="fw-bold">Simple, Transparent Pricing</h2>
                    <p className="text-muted">
                    We keep both up-front and ongoing fees low. With our model, we succeed when you succeed.
                    </p>
                </Col>
            </Row>

          <Row className="justify-content-center">
            <Col xs={12} md={8}>
              <Card className="shadow-sm">
                <Card.Body>
                  <h5 className="fw-semibold mb-3">Our Pricing Structure</h5>
                  <ul className="text-muted">
                    <li>
                      <strong>Device Purchase:</strong> Buy Level 2 chargers at competitive, model-dependent pricing,
                      each with a 2–5 year replacement warranty.
                    </li>
                    <li>
                      <strong>Usage Fee:</strong> We charge a low percentage of every kWh sold. You keep the rest.
                    </li>
                    <li>
                      <strong>Annual Communications Fee:</strong> A fixed, low yearly fee per charger to stay on our smart network
                      (e.g. $100 /yr per unit, negotiable depending on volume).
                    </li>
                  </ul>
                  <p className="mt-3">
                    Everything else is negotiable—installation is handled by your electrician (we can recommend locally),
                    and there are no hidden fees. You pay only for the chargers you buy + what you use + a simple
                    yearly network fee.
                  </p>
                  <div className="text-center mt-4">
                    <Button 
                                  variant="warning"
                                  className="mx-2 px-4 py-2 text-dark fw-semibold"
                                  href="/business-owners/support"
                                  >
                      Contact Sales to Negotiate Terms
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>


        

            
            <Col xs={12} md={8}>
              <Card className="text-center shadow-sm">
                <Card.Body className="d-flex align-items-center justify-content-center">
                  <img
                    src="/images/landingPageJune2025/incentive.png"
                    alt="Incentive icon"
                    width="80"
                    height="80"
                    className="me-2"
                  />
                  <p className="mb-0">
                    <strong>Federal & State EV Incentives</strong> – Many properties qualify for up to $4,000 per port rebate.{' '}
                    <a href="/incentives/usa-map" className="text-success text-decoration-underline">
                      See if you’re eligible →
                    </a>
                  </p>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          

          
        </Container>
      </Row>

      {/* ================= FAQ Accordion ================= */}
      <Row className="py-5 bg-light">
        <Container>
          <Col xs={12} className="text-center mb-4">
            <h2 className="fw-bold">Frequently Asked Questions</h2>
          </Col>
          <Col xs={12} md={8} className="mx-auto">
            <Accordion>
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  How do I install the chargers?
                </Accordion.Header>
                <Accordion.Body>
                  You purchase chargers directly from us. We ship them to you, then you or your electrician
                  (we can recommend a local electrician if needed) installs each unit. After installation,
                  we guide you through connecting them to our network—no markup on installation labor.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  What does EVChron handle vs. what I’m responsible for?
                </Accordion.Header>
                <Accordion.Body>
                  <ul>
                    <li>
                      <strong>EVChron Handles:</strong> Shipping chargers, smart network setup, payment processing, customer support,
                      remote diagnostics, and warranty replacements if a unit fails, basically everything except the installation.
                      we really are a true turnkey solution.
                    </li>
                    <li>
                      <strong>You Handle:</strong> Electrical installation via your electrician
                      (licensed per local code), utility coordination if needed, and on-site mounting.
                    </li>
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2">
                <Accordion.Header>How is pricing structured?</Accordion.Header>
                <Accordion.Body>
                  We keep fees low and align incentives:
                  <ul>
                    <li>Buy chargers at competitive, model-dependent pricing (2–5 year warranty included).</li>
                    <li>Pay a low percentage And/Or a fixed fee of each kWh sold. You keep the rest of the revenue.</li>
                    <li>Pay a small fixed yearly communications fee per charger (e.g. $100 /yr, negotiable).</li>
                  </ul>
                  Any additional customization is negotiable, so you never pay more than you need to
                  get started.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="3">
                <Accordion.Header>What happens if a charger breaks?</Accordion.Header>
                <Accordion.Body>
                  All units are under a 2–5 year warranty (depending on model). Our remote diagnostics
                  team monitors each charger 24/7. If hardware fails, we ship a replacement unit at no
                  extra labor cost. Simply swap the old unit for the new one.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="4">
                <Accordion.Header>Can I track usage per apartment/resident?</Accordion.Header>
                <Accordion.Body>
                  Absolutely. Our cloud dashboard lets you assign specific chargers to individual units
                  or allow residents to reserve via your tenant portal. You’ll have detailed
                  per-session and per-unit reports in real time.
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Col>
        </Container>
      </Row>

      {/* ============== Final CTA Section ============== */}
      <Row className="py-5" style={{ backgroundColor: '#0A3D35' }}>
        <Container>
          <Col xs={12} className="text-center text-white mb-4">
            <h2 className="fw-bold">Turn Idle Parking into Recurring Income Today</h2>
            <p className="mb-4">Get in touch today for a free quote, no obligation, no fees.</p>
          </Col>
          <Col xs={12} className="text-center">
            <Button
              variant="warning"
              className="mx-2 px-4 py-2 text-dark fw-semibold"
              href="/business-owners/support"
            >
              Get a Free Quote
            </Button>
  
          </Col>
          <Col xs={12} className="text-center mt-3">
            <small className="text-white-50">
              By clicking, you agree to receive occasional updates from EVChron. We respect your privacy.
            </small>
          </Col>
        </Container>
      </Row>

      <Footer />
    </Container>
  );
};

export default LandingPage;
